import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

const PopupModal = (props) => {
    const { data, isPopupOpen, setIsPopupOpen } = props;

    function closeModal() {
        setIsPopupOpen(false)
    }

    return (
        <Transition appear show={isPopupOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white/95 dark:bg-gray-800/95 backdrop-blur-xl p-6 pb-3 text-left align-middle shadow-2xl transition-all border border-gray-200/50 dark:border-gray-700/50">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-bold leading-6 text-red-600 dark:text-red-400 flex items-center gap-2"
                                >
                                    <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                                    Announcement
                                </Dialog.Title>
                                <div className="mt-1">
                                    {
                                        data?.map((d, index) => (
                                            <div key={index} className='text-sm text-gray-700 dark:text-gray-200 py-1 border-l-2 border-red-200 dark:border-red-800 pl-3 mb-2'>{d?.displayText}</div>
                                        ))
                                    }
                                </div>
                                <div className="mt-4 w-full flex justify-end">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center rounded-xl border border-transparent bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 px-6 py-3 text-sm font-bold text-white shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-red-300"
                                        onClick={closeModal}
                                    >
                                        CLOSE
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default PopupModal